package one.healthium.profile.ui.update_weight

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.composables.core.Icon
import loco.GENERAL_SAVE
import loco.UPDATE_WEIGHT_LOG_SCREEN_TITLE
import one.healthium.profile.ui.weight.WeightPicker
import one.healthium.ui.common.event_producer.EventEffect
import one.healthium.ui.common.message.AlertUiMessageHandler
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.components.AppProgressButton
import one.healthium.ui.compose.components.AppSheetTopBar
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black50
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import kotlin.time.Instant

interface UpdateWeightEventDelegate {
    fun onWeightUpdated()
    fun onCloseClicked()
}

@Composable
fun UpdateWeightScreen(
    weight: Float,
    date: Instant,
    eventDelegate: UpdateWeightEventDelegate,
) {
    val viewModel = koinViewModel<UpdateWeightViewModel>()
    val state by viewModel.state(weight, date).collectAsState()

    EventEffect(viewModel.events) { event ->
        when (event) {
            UpdateWeightEvent.OnWeightUpdated -> eventDelegate.onWeightUpdated()
        }
    }

    UpdateWeightScreenContent(
        state = state,
        onWeightChanged = viewModel::onWeightChanged,
        onSaveClicked = viewModel::onSaveClicked,
        onCloseClicked = eventDelegate::onCloseClicked,
    )

    AlertUiMessageHandler(viewModel.uiMessages)
}

@Composable
private fun UpdateWeightScreenContent(
    state: UpdateWeightUiState,
    onWeightChanged: (Float) -> Unit,
    onSaveClicked: () -> Unit,
    onCloseClicked: () -> Unit,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        AppSheetTopBar(
            onCloseClicked = onCloseClicked,
        )
        Icon(
            modifier = Modifier.size(46.dp),
            painter = painterResource(AppIcons.icFileChecked),
            tint = black50,
            contentDescription = null,
        )
        Spacer(Modifier.height(16.dp))
        Text(
            modifier = Modifier.padding(horizontal = 32.dp),
            text = stringResource(loco.Res.string.UPDATE_WEIGHT_LOG_SCREEN_TITLE),
            style = AppTheme.logWeightControlStyle?.titleStyle ?: AppTheme.textStyles.titleMedium,
            color = AppTheme.colors.text100,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(30.dp))
        WeightPicker(
            currentWeight = state.currentWeight,
            isMetric = state.isMetric,
            onWeightChanged = onWeightChanged,
        )
        Spacer(Modifier.height(30.dp))
        AppProgressButton(
            modifier = Modifier.defaultMinSize(minWidth = 176.dp),
            text = stringResource(loco.Res.string.GENERAL_SAVE),
            loading = state.loading,
            onClick = onSaveClicked,
        )
        Spacer(Modifier.height(50.dp))
    }
}
